import React from 'react';
import PropTypes from 'prop-types';

import styles from './Message.module.scss';

const Type = {
    Default: 'default',
    Error: 'error',
    Success: 'success',
    Warning: 'warning',
    Info: 'info',
    Light: 'light',
};

const Message = ({ children, type, onClose }) => {

    const [isClosed, setIsClosed] = React.useState(false);
    const handleOnClose = () => {
        setIsClosed(true);
        onClose && onClose();
    };

    return (
        <div className={`${styles['message-component']} ${styles[type || Type.Default]} ${isClosed ? styles['is-closed'] : ``}`}>
            <div className={styles.wrapper}>
                <span className={styles.message}>{children}</span>
                <span className={`${styles.close} icon icon-close`} onClick={handleOnClose} />
            </div>
        </div>
    );
};

Message.propTypes = {
    children: PropTypes.any,
    type: PropTypes.oneOf([
        Type.Default,
        Type.Error,
        Type.Success,
        Type.Warning,
        Type.Info,
        Type.Light,
    ]),
    onClose: PropTypes.func,
};

export default Message;
export { Type as MessageType };
